import axios from 'axios';
import { ICouponDetailsModel } from './CouponDetailsModel';

// Base URL ayarı
const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

//  BASE URL 
export const COUPON_DETAILS_CREATE_URL = `${API_URL}api/v1/definition/details-coupon-management/create`;
export const COUPON_DETAILS_GET_ALL_URL = `${API_URL}api/v1/definition/details-coupon-management/all`;
export const COUPON_DETAILS_DELETE_URL = `${API_URL}api/v1/definition/details-coupon-management/delete/`;
export const COUPON_DETAILS_UPDATE_URL = `${API_URL}api/v1/definition/details-coupon-management/update/`;

// Authorization header helper
const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
};

// ✅ Create Location (id gönderilmez)
export function createCouponDetails(couponData: ICouponDetailsModel) {
    const { id, ...dataWithoutId } = couponData; // id'yi göndermiyoruz
    return axios.post(COUPON_DETAILS_CREATE_URL, dataWithoutId, {
        headers: {
            ...getAuthHeaders(),
            'Content-Type': 'application/json',
        },
        withCredentials: true,
    });
}

// ✅ Update Location (/update/{id})
export function updateCouponDetails(couponData: ICouponDetailsModel) {
    return axios.post(COUPON_DETAILS_UPDATE_URL + couponData.id, couponData, {
        headers: {
            ...getAuthHeaders(),
            'Content-Type': 'application/json',
        },
        withCredentials: true,
    });
}



// ✅ Load all locations (pageable destekli)
export function loadCouponDetails(page = 0) {
    return axios
        .get(COUPON_DETAILS_GET_ALL_URL, {
            headers: getAuthHeaders(),
            params: { page, size: 20 },
            withCredentials: true,
        })
        .then((res) => ({
            ...res,
            data: res.data.payload?.content || res.data.payload || res.data,
        }));
}

// ✅ Delete Location (/delete/{id})
export function deleteCouponDetails(couponId: string) {
    return axios.post(COUPON_DETAILS_DELETE_URL + couponId);
}

